module.exports = __webpack_public_path__ + "img/cooperationAdvantagesImg1.e71f66ee.png";